import React from 'react';

import { BiInfoCircle } from 'react-icons/bi';
import { Container, TooltipContainer } from './styles';

type TooltipItemProps = {
  text: string;
};

const TooltipItem: React.FC<TooltipItemProps> = ({ text }) => {
  const [isTooltipOpen, setIsTooltipOpen] = React.useState(false);
  return (
    <Container onClick={() => setIsTooltipOpen((prev) => !prev)}>
      <BiInfoCircle />
      {isTooltipOpen && (
        <TooltipContainer>
          <span>{text}</span>
        </TooltipContainer>
      )}
    </Container>
  );
};

export default TooltipItem;
